export default {"src":"/_next/static/media/setting.73b852df.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};